export class DadosCartao {
  numero: string;
  ultimosNumeros: string;
  cvv: string;
  nome: string;
  validade: Date;
  email: string;
  cpf: string;
  dataNascimento: string;
  senderHash: string;
  token: string;
  cryptData: string;
  endereco: any;
  usarEnderecoDeEntrega: boolean;
  bandeira: string;
  autenticacao3ds: any;
  autenticacao3dsNaoSuportada: boolean;
  autenticacao3dsStatus: string;
  autenticacao3dsMotivo: string;
  autenticouCarteiraDigital: any;
  valorPagamento: number;
  parcela: number
  tokenize: any;
  tipoDoCartao: any;
  deviceInfo: any;
  tokenSession: string;
  externalProvider: string;
  descricaoPagamento: string;
  cartaoSalvoId: string;
  salvarCartao: boolean;
  constructor() {
    this.cvv = ''
  }

  setRetornoTokenCartaoPagarme(res: any, tokenize: any ){
    this.token = res.id;
    this.bandeira = res.card.brand;
    this.tokenize = tokenize
  }

  outroSemDadosSensitivos() {
    const outro = new DadosCartao();

    outro.nome = this.nome;
    outro.cpf = this.cpf;
    outro.dataNascimento = this.dataNascimento;
    outro.senderHash = this.senderHash;
    outro.email = this.email;
    outro.token = this.token;
    outro.cryptData = this.cryptData;
    outro.bandeira = this.bandeira;
    outro.endereco = this.endereco;
    outro.usarEnderecoDeEntrega = this.usarEnderecoDeEntrega;
    outro.ultimosNumeros = this.ultimosNumeros || (this.numero ? this.numero.slice(-4) : '****' );
    outro.autenticacao3ds = this.autenticacao3ds;
    outro.autenticacao3dsNaoSuportada = this.autenticacao3dsNaoSuportada;
    outro.autenticacao3dsStatus = this.autenticacao3dsStatus;
    outro.autenticacao3dsMotivo = this.autenticacao3dsMotivo;
    outro.autenticouCarteiraDigital = this.autenticouCarteiraDigital;
    outro.valorPagamento = this.valorPagamento;
    outro.parcela = this.parcela;
    outro.tipoDoCartao = this.tipoDoCartao;
    outro.validade = this.validade;
    outro.cartaoSalvoId = this.cartaoSalvoId;
    outro.salvarCartao = this.salvarCartao;

    if(this.tokenize) outro.tokenize = this.tokenize;
    if(this.deviceInfo) outro.deviceInfo = this.deviceInfo
    if(this.tokenSession) outro.tokenSession = this.tokenSession;
    if(this.externalProvider)
      outro.externalProvider = this.externalProvider;

    if(this.descricaoPagamento)
      outro.descricaoPagamento = this.descricaoPagamento;
    else {
      try{
        // Visa ****1111 12/2026
        let validade = this.validade ?
          `${new Date(this.validade).getMonth() + 1}/${new Date(this.validade).getFullYear()}` : ''
        let descricao = `${this.bandeira} ****${outro.ultimosNumeros} ${validade}`.trim()
        outro.descricaoPagamento = descricao;
      }catch (err){  }


    }


    return outro;
  }
}
